<template lang="pug">
  div.tendency-change
    div.header
      module-title(title="舆情倾向变化")
      div.legends
        div.legend(v-for="legend in legends" :key="legend.name")
          div.square(:style="{backgroundColor: legend.color}")
          span {{legend.name}}
    div.changes
      div.name.change
        div.before 公关前
        div.compare
        div.after 公关后
      div.pos.change
        div.before
          span {{change.beforePos}}
          div.bar(:style="{width: `calc(${change.beforePos} * 0.7)`}")
        div.compare(:class="change.comparePosType")
          i.fa(:class="`fa-${change.comparePosType}`")
          span {{change.comparePos}}
        div.after
          div.bar(:style="{width: `calc(${change.afterPos} * 0.7)`}")
          span {{change.afterPos}}
      div.neg.change
        div.before
          span {{change.beforeNeg}}
          div.bar(:style="{width: `calc(${change.beforeNeg} * 0.7)`}")
        div.compare(:class="change.compareNegType")
          i.fa(:class="`fa-${change.compareNegType}`")
          span {{change.compareNeg}}
        div.after
          div.bar(:style="{width: `calc(${change.afterNeg} * 0.7)`}")
          span {{change.afterNeg}}
</template>

<script>
import ModuleTitle from '../EventCenter/ModuleTitle'
export default {
  name: 'TendencyChange',
  components: {
    ModuleTitle
  },
  props: {
    change: {}
  },
  data () {
    return {
      legends: [
        {
          name: '正面舆情',
          color: '#5dca6f'
        },
        {
          name: '负面舆情',
          color: '#ff7676'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .tendency-change{
    flex: 7;
    height: 160px;
    background-color: #ffffff;
    border-radius: 4px;
    padding: 14px;
    .header{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .legends{
        display: flex;
        align-items: center;
        .legend{
          display: flex;
          align-items: center;
          margin-left: 20px;
          .square{
            width: 10px;
            height: 10px;
            margin-right: 8px;
          }
          span{
            font-size: 12px;
          }
        }
      }
    }
    .changes{
      margin-top: 20px;
      font-size: 12px;
      .change{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
        .bar{
          height: 12px;
        }
        &.neg{
          margin-top: 10px;
          .bar{
            background-color: #ff7676;
          }
        }
        &.pos{
          .bar{
            background-color: #5dca6f;
          }
        }
        .before{
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          span{
            margin-right: 10px;
          }
        }
        .after{
          flex: 1;
          display: flex;
          align-items: center;
          span{
            margin-left: 10px;
          }
        }
        .compare{
          min-width: 200px;
          text-align: center;
          i{
            margin-right: 14px;
          }
          &.caret-up{
            color: #5dca6f;
          }
          &.caret-down{
            color: #ff7676;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/EventTendency/TendencyChange.vue